export function deepEqual(x, y, hash = new WeakMap()) {
    if (x === y) {
        return true;
    }
    else if (typeof x === 'object' &&
        x != null &&
        typeof y === 'object' &&
        y != null) {
        const existingCheck = hash.get(x);
        if (existingCheck !== undefined) {
            return existingCheck;
        }
        hash.set(x, true);
        if (Object.keys(x).length !== Object.keys(y).length) {
            hash.set(x, false);
            return false;
        }
        for (const prop in x) {
            if (y.hasOwnProperty(prop)) {
                if (!deepEqual(x[prop], y[prop], hash)) {
                    return false;
                }
            }
            else {
                hash.set(x, false);
                return false;
            }
        }
        hash.set(x, true);
        return true;
    }
    else
        return false;
}
